/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PostSearchDataItemQueryOrderProperty {
    Provider = 'Provider',
    Route = 'Route',
    TotalFare = 'TotalFare',
    TotalTax = 'TotalTax',
    TotalPrice = 'TotalPrice',
    TicketingCarrier = 'TicketingCarrier',
    FareType = 'FareType',
    TTL = 'TTL',
    Class = 'Class'
}

export function PostSearchDataItemQueryOrderPropertyFromJSON(json: any): PostSearchDataItemQueryOrderProperty {
    return PostSearchDataItemQueryOrderPropertyFromJSONTyped(json, false);
}

export function PostSearchDataItemQueryOrderPropertyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostSearchDataItemQueryOrderProperty {
    return json as PostSearchDataItemQueryOrderProperty;
}

export function PostSearchDataItemQueryOrderPropertyToJSON(value?: PostSearchDataItemQueryOrderProperty | null): any {
    return value as any;
}

